import React from "react";
import { Row, Col, Typography } from "antd";
import { Fade } from "react-awesome-reveal";

interface MainHeaderProps {
  title: string;
  imageSrc: string;
  text: string;
}

const MainHeader: React.FC<MainHeaderProps> = ({ imageSrc, text, title }) => {
  const styles = {
    color: "#fff",
  };

  return (
    <>
      <Row className="listView-bgi">
        <Col lg={2}></Col>
        <Col lg={20}>
          <Row
            align="middle"
            className="listView-bgi"
            style={{ paddingTop: 10, paddingBottom: 10 }}
          >
            <Col lg={12}>
              <Fade direction="left" triggerOnce>
                <Typography.Title
                  level={2}
                  style={{ color: "#fff", marginBottom: 20 }}
                >
                  {title}
                </Typography.Title>
                <Typography.Text style={styles}>{text}</Typography.Text>
              </Fade>
            </Col>
            <Col lg={12}>
              <Fade direction="right" triggerOnce>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <img
                    src={imageSrc}
                    alt="img"
                    style={{
                      position: "relative",
                      bottom: "-40px",
                      maxWidth: 350,
                      maxHeight: 200,
                    }}
                  />
                </div>
              </Fade>
            </Col>
          </Row>
        </Col>
        <Col lg={2}></Col>
      </Row>
    </>
  );
};

export default MainHeader;
